<template>
  <div class="modal-backdrop">
    <!-- Put the tiltle and 3 radio button -->
    <div v-if="!logged" class="modal">
      <div class="modalContainer">
        <h2>
          Mark your progress towards completing this measurable criteria last
          week
        </h2>
        <div class="radioContainer">
          <div class="progressRadio">
            <input
              class="radioInput"
              type="radio"
              id="notcompleted"
              name="no"
              value="none"
              v-model="progress"
            />
            <label>I have not completed this goal</label>
          </div>
          <div class="progressRadio">
            <input
              class="radioInput"
              type="radio"
              id="partially"
              name="partially"
              value="partially"
              v-model="progress"
            />
            <label>I have partially completed this goal</label>
          </div>
          <div class="progressRadio">
            <input
              class="radioInput"
              type="radio"
              id="fully"
              name="fully"
              value="fully"
              v-model="progress"
            />
            <label>I have fully completed this goal</label>
          </div>
        </div>
      </div>
      <div>
        <button class="btn" @click="log">Submit</button>
      </div>
    </div>
    <div v-else>
      <!-- Successfully logged -->
      <div class="modal-backdrop">
        <div class="loggedConfirm">
          <img class="thumbsup" src="../assets/thumbsup.svg" alt="" />
          <h4>
            Way to go! You’ve successfully logged your progress for last week.
          </h4>
          <div>
            <button class="btn" @click="$emit('close')">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logged: false,
      progress: "",
    };
  },
  methods: {
    log() {
      this.$emit("setProgress", this.progress);
      this.logged = true;
    },
  },
};
</script>
<style scoped>
.btn {
  width: 139px;
  height: 52px;
  margin: 25px 0px;
  background: linear-gradient(
    96.18deg,
    #03a3f5 -5.4%,
    #b983ff 50.72%,
    #ffe883 85.14%
  );
  box-shadow: 0px 7px 10px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  border: 0px;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: #ffffff;
  cursor: pointer;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  padding: 1rem;
  flex-direction: column;
}
.modalContainer {
  width: 40%;
  margin: 0 auto;
  padding: 20px;
}

.radioContainer {
  margin: 0 auto;
  padding-left: 20px;
}

.progressRadio {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 20px auto;
  vertical-align: top;
}

.progressRadio > input {
  width: 5%;
}

.progressRadio > label {
  width: 100%;
  text-align: left;
  padding-left: 15px;
}

.thumbsup {
  height: 64px;
  margin: 2rem;
}

.loggedConfirm {
  width: 25%;
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  padding: 1rem;
  flex-direction: column;
}
</style>
